import script from "./AppLists.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppLists.vue?vue&type=script&setup=true&lang=ts"

import "./AppLists.vue?vue&type=style&index=0&id=01b3d42a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01b3d42a"]])

export default __exports__